var createIsSubmitting = function createIsSubmitting(_ref) {
  var getIn = _ref.getIn;
  return function (form) {
    var getFormState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (state) {
      return getIn(state, 'form');
    };
    return function (state) {
      var formState = getFormState(state);
      return getIn(formState, form + '.submitting') || false;
    };
  };
};

export default createIsSubmitting;


//////////////////
// WEBPACK FOOTER
// ../~/redux-form/es/selectors/isSubmitting.js
// module id = 712
// module chunks = 7